import { ToastDescriptionVariants } from './toast-description.styles'

type ToastDescriptionProps = {
  children: React.ReactNode
}
export const ToastDescription = (props: ToastDescriptionProps) => {
  const { children } = props

  return (
    <span
      className={ToastDescriptionVariants()}
      data-testid="toast-description"
      aria-label={`${children?.toString()}`}
    >
      {children}
    </span>
  )
}
